import { makeStyles } from '@material-ui/core/styles';
import { mergeStyles } from './stylesSelector';
import { cloneDeep } from 'lodash';
import { CONTENT_MAX_WIDTH, CONTENT_MIN_WIDTH, styleBreakMobile, styleBreakSmallMobile, styleBreakDesktop } from '../components/utilities/layouts/Globals';
import { COLOR_WHITE } from '../components/utilities/Material';

// This function will merge custom overrides.
export const MainLayoutStyle = stylesOverride => {
    return makeStyles(theme => {
        const defaultstyles = {
            container: {
                minWidth: CONTENT_MIN_WIDTH,
                maxWidth: CONTENT_MAX_WIDTH,
                height: '100%',
                marginLeft: 'auto',
                marginRight: 'auto',
                [theme.breakpoints.down(theme.breakpoints.values['md'])]: {
                    marginLeft: theme.spacing(2),
                    marginRight: theme.spacing(2),
                },
                [theme.breakpoints.between(theme.breakpoints.values['md'], theme.breakpoints.values['lg'])]: {
                    marginLeft: theme.spacing(3),
                    marginRight: theme.spacing(3),
                },
                [styleBreakSmallMobile(theme)]: {
                    marginLeft: 0,
                    marginRight: 0,
                    padding: theme.spacing(1),
                },
            },
            verticalOverlay: {
                [styleBreakMobile(theme)]: {
                    overflowY: 'overlay',
                },
            },
            mainLayoutDiv: {
                position: 'relative',
                maxWidth: '100%',
                [styleBreakDesktop(theme)]: {
                    paddingTop: theme.spacing(10),
                },
            },
            hiddenOverflowX: {
                overflowX: 'hidden',
            },
            noVisitDiv: {
                height: '100vh',
                background: COLOR_WHITE,
            },
        };

        // overrides the default
        return mergeStyles(cloneDeep(defaultstyles), stylesOverride || {});
    });
};
